
import { remindControlPin } from '../../requests/loader';
import Utils from '../Utils';
import AAF from '../../AAF/AAF';
import { STATUS_CONTROL_PIN_TTL } from 'src/AAF/Resilence/TTLConstants';

const TTLItem = STATUS_CONTROL_PIN_TTL;

//critica
export const CONTROL_PIN_STATUS_API = '/services/user/controlpin/status';
//no critica
export const STATUS_CONTROL_PIN_API = '/services/user/statuscontrolpin';

let apiToUsePinStatus = STATUS_CONTROL_PIN_API;
let idTimer = null;

export const setApiToUsePinStatus = (api) => {
  apiToUsePinStatus = api;
}

export const getApiToUsePinStatus = () => {
  AAF.TTLUtil.setStorageItemTTL(TTLItem);

  return apiToUsePinStatus;
}

const getDefaultSecondsToValidateApiToUse = () => {
  try{
    return Utils.getApaMetadataKey('validate_controlpinstatus_seconds','{"default":5}', 'default');
  }
  catch(err){
    return 5
  }
}

export const initTimerApiToUsePinStatus = () => {
  const seconds =  getDefaultSecondsToValidateApiToUse();

  setApiToUsePinStatus(CONTROL_PIN_STATUS_API);
  AAF.TTLUtil.setStorageItemTTL(TTLItem);

  if(!idTimer){
    idTimer = setTimeout(()=>{
      setApiToUsePinStatus(STATUS_CONTROL_PIN_API);
      clearTimeout(idTimer);
      idTimer = null;
      AAF.TTLUtil.setStorageItemTTL(TTLItem);
    }, seconds * 1000);
  }
}
class UtilsPin {

  static sleep(seconds) {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }

  static async sendRemind() {
    let requestParams = {};
    let functionToRequest = () => {
    };
    functionToRequest = this.performRemindControlPin;
    const response = await functionToRequest(requestParams);
    console.log(response);
  }

  static async performRemindControlPin(params = {}) {
    const response = {success: false};
    try {
      const result = await remindControlPin(params);
      if (result && result.status == '0') {
        response.success = true;
      }
    } catch (error) {
      response.error = error;
    }
    return response;
  }

}

export default UtilsPin;



// WEBPACK FOOTER //
// ./src/utils/pinParental/UtilsPin.js